import React, { useState, useEffect, useContext } from "react";
import UserAppAccessReadOnlyRow from "./UserAppAccessReadOnlyRow";
import UserAppAccessTableRow from "./UserAppAccessTableRow";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

function UserAppAccessTable({ key, setAppAccess, appAccess, fidesRoles, factbookRoles,
	fairRoles, idirtRoles, cristalRoles, appNames, userId, refetch }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [error, setError] = useState("");
	const [userAppAccess, setUserAppAccess] = useState([]);
	const [appAccessLoaded, setAppAccessLoaded] = useState(false);
	const [subkeyCount, setSubkeyCount] = useState(key);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		userId: userId,
		appName: "",
		appRole: "",
		subscriptionDate: ""
	};
	const [formValues, setFormValues] = useState(initialValues);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchUserAppAccess();
	}, []);

	const handleClose = (event) => {
		setAppAccess(false);
	};

	function fetchUserAppAccess() {
		setAppAccessLoaded(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true,
				loginId: userId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserAppAccess", "/Service/UserService/GetUserAppAccess", requestOptions, getAppAccessSuccess, getAppAccessFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getAppAccessFail(redirect) {
		setError(t("error.getAppNamesFailed"));
	}
	function getAppAccessSuccess(responseData) {
		let getUserAppAccessResponse;
		if (responseData) {
			getUserAppAccessResponse = responseData.getUserAppAccessResponse;
			if (getUserAppAccessResponse && getUserAppAccessResponse.errorCode === "0") {
				setUserAppAccess(getUserAppAccessResponse.appAccessList.slice());
				setAppAccessLoaded(true);
			} else if (getUserAppAccessResponse && getUserAppAccessResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getUserAppAccessResponse) {
				setError(t("error.error") + " " + getUserAppAccessResponse.errorMessage);
			}
		}
	}
	const handleDeleteClick = (event, appAccessItem, completeCallback) => {
		event.preventDefault();
		deleteUserAppAccess(appAccessItem, completeCallback);
	};
	const deleteUserAppAccess = (appAccessItem, completeCallback) => {
		let action = 3;
		if (appAccessItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: userId,
			appNameToChange: appAccessItem.appName,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserAppAccess", "/Service/UserService/DeleteUserAppAccess", requestOptions, deleteUserAppAccessSuccess, deleteUserAppAccessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteUserAppAccessFail(redirect, completeCallback) {
		setError(t("error.appAccessEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteUserAppAccessSuccess(responseData, completeCallback) {
		let deleteUserAppAccessResponse;
		if (responseData) {
			deleteUserAppAccessResponse = responseData.deleteUserAppAccessResponse;
			if (deleteUserAppAccessResponse) {
				if (deleteUserAppAccessResponse.errorCode === "0") {
					setAdd(false);
					//setAppAccess(false);
					refreshUserAppAccess("");
				} else {
					setError(t("error.error") + " " +
						deleteUserAppAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.userId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userAppAccess.length > 0) {
				userAppAccess.map((appAccessItem, index) => {
					if (appAccessItem.appName === setValues.appName) {
						setError(t("error.appAccessDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserAppAccess(action, setValues, completeCallback);
			}
		} else {
			saveUserAppAccess(action, setValues, completeCallback);
		}
	};
	const saveUserAppAccess = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.userId,
			appNameToChange: setValues.appName,
			appRole: setValues.appRole,
			subscriptionDate: setValues.subscriptionDate,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("SaveUserAppAccess", "/Service/UserService/SaveUserAppAccess", requestOptions, saveUserAppAccessSuccess, saveUserAppAccessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserAppAccessFail(redirect, completeCallback) {
		setError(t("error.appAccessEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserAppAccessSuccess(responseData, completeCallback) {
		let saveUserAppAccessResponse;
		if (responseData) {
			saveUserAppAccessResponse = responseData.saveUserAppAccessResponse;
			if (saveUserAppAccessResponse) {
				if (saveUserAppAccessResponse.errorCode === "0") {
					setAdd(false);
					//setAppAccess(false);
					refreshUserAppAccess("");
				} else if (saveUserAppAccessResponse.errorCode === "1111") {
					setAdd(false);
					//setAppAccess(false);
					refreshUserAppAccess(saveUserAppAccessResponse.errorMessage);
				} else {
					setError(t("error.error") + " " +
						saveUserAppAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserAppAccess(errorMessage) {
		setSubkeyCount(prevCount => prevCount + 1);
		refetch();
		fetchUserAppAccess();
		if (errorMessage) {
			alert(errorMessage);
		}
		setError(errorMessage);
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div key={subkeyCount} className="modalContainer hide-scrollbar">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.application")}</th>
										<th className="list-th">{t("page.role")}</th>
										<th className="list-th">{t("page.subDate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTable}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add &&
										<UserAppAccessTableRow
											key={subkeyCount}
											appNames={appNames}
											fidesRoles={fidesRoles}
											factbookRoles={factbookRoles}
											fairRoles={fairRoles}
											idirtRoles={idirtRoles}
											cristalRoles={cristalRoles}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userAppAccess.length % 2) > 0) ? true : false} />
									}
									{(appAccessLoaded && (userAppAccess.length > 0)) ? (
										userAppAccess.map((appAccessItem, index) => (
											appAccessItem.appName !== "Customer" ?
												<UserAppAccessReadOnlyRow
													key={subkeyCount}
													t={t}
													appAccessItem={appAccessItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													add={add}
													setError={setError}
													fidesRoles={fidesRoles}
													factbookRoles={factbookRoles}
													fairRoles={fairRoles}
													idirtRoles={idirtRoles}
													cristalRoles={cristalRoles}
													handleSubmit={handleSubmit}
												/> : ""
										))
									) : (<></>)}
								</tbody>
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-userappaccess-close"
									id="edit-userappaccess-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserAppAccessTable;